import make, { Enum } from '@xaamin/enum';

class AutofacturacionTicketStatus extends Enum {

  name = 'AutofacturacionTicketStatus';

  enum = {
    pending: 0,
    cancelled: -1,
    error: -2,
    failed: -3,
    success: 1,
    stamping: 2,
    duplicate: 3,
    reserved: 4,
    fpg: 5,
    lock: 6,
    replace: 7,
    queued: 8,
    individual: 9,
    processing: 10,
    blocked: 11,
    unprocessed: 12,
    undefined: 999
  }

}

export default make(AutofacturacionTicketStatus);